import styles from '../../assets/css/accounts.module.css';
import { Account } from '../../types/account';

interface AccountDetailsProps {
	account: Account;
}

const AccountDetails = ({ account }: AccountDetailsProps) => {
	return (
		<div className={styles['account-details']}>
			<div>
				{account.alias && (
					<span className={'account-alias'}>
						{account.alias} {account.holderName && `(${account.holderName})`}
					</span>
				)}
			</div>
		</div>
	);
};

export default AccountDetails;
